export default "__VITE_ASSET__wnTfT1Yt__"